import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toastEmitter } from "../../utils/utilities";
import { MAILICON, RIGHTARROW_IMG } from "../../utils/aap-image-constant";
import {
  VerifDoctorEmail,
  VerifEmail,
} from "../../hooks/services/api-services";

const VerifyEmail = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  // STATUS: PENDING | SUCCESS | ERROR
  const [status, setStatus] = useState("PENDING");

  const [payload, setPayload] = useState({
    id: "",
    email: "",
    token: "",
    type: "",
  });

  //  Read URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const id = params.get("id");
    const email = params.get("email");
    const token = params.get("token");
    const type = params.get("type");

    if (!id || !token || !type) {
      toastEmitter("error", "Invalid verification link");
      setStatus("ERROR");
      return;
    }

    setPayload({ id, email, token, type });
  }, [location.search]);

  //  VERIFY HANDLER
  const handleVerify = async () => {
    if (!payload.id || !payload.token || !payload.type) {
      toastEmitter("error", "Invalid verification data");
      setStatus("ERROR");
      return;
    }
    try {
      setIsLoading(true);
      let response;

      if (payload.type === "Clinic") {
        response = await VerifEmail(payload.id, payload.token);
      } else if (payload.type === "Doctor") {
        response = await VerifDoctorEmail(payload.id, payload.token);
      } else {
        toastEmitter("error", "Invalid user type");
        setStatus("ERROR");
        return;
      }

      // IMPORTANT CHECK
      if (response?.data?.responseCode !== 200) {
        toastEmitter(
          "error",
          response?.data?.message || "Verification failed"
        );
        setStatus("ERROR");
        return;
      }

      toastEmitter(
        "success",
        response?.data?.message || "Email verified successfully"
      );

      setStatus("SUCCESS");
    } catch (error) {
      toastEmitter(
        "error",
        error?.response?.data?.message ||
        "Verification link is invalid or already used"
      );
      setStatus("ERROR");
    } finally {
      setIsLoading(false);
    }

  };


  /* =========================
     SUCCESS SCREEN
  ========================== */
  if (status === "SUCCESS") {
    return (
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="card shadow border-0 text-center p-5">
          <div className="d-flex align-items-center justify-content-center ">
            <img
              src={RIGHTARROW_IMG}
              alt="success"
              className="mailicon mb-3"
            />

          </div>

          <h5 className="fw-semibold text-primary mb-2">
            Email Verified Successfully
          </h5>

          <p className="text-muted mb-2">
            Your email has been verified successfully.<br />
            You can now go to the login page
          </p>

          {/* <button
            className="btn btn-primary mt-3"
            onClick={() => navigate(ROUTES.LOGIN)}
          >
            Go to Login
          </button> */}

          <p className="text-muted small mt-3 mb-0">
            <strong>Team Medier</strong>
          </p>
        </div>
      </div>
    );
  }

  /* =========================
     ERROR SCREEN
  ========================== */
  if (status === "ERROR") {
    return (
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="card shadow border-0 text-center p-5">
          <h5 className="fw-semibold text-danger mb-2">
            Verification Failed
          </h5>

          <p className="text-muted mb-3">
            This verification link is invalid, expired, or already used.<b />
            You can now go to the login page
          </p>

          <p className="text-muted small mt-3 mb-0">
            <strong>Team Medier</strong>
          </p>
        </div>
      </div>
    );
  }

  /* =========================
     PENDING / VERIFY SCREEN
  ========================== */
  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 justify-content-center">
        <div className="col-11 col-sm-9 col-md-7 col-lg-5">
          <div className="card shadow border-0 text-center p-5">
            <div className="d-flex align-items-center justify-content-center ">

              <img src={MAILICON} alt="mail" className="mailicon mb-3" />
            </div>

            <h5 className="fw-semibold mb-1">
              Verify your email address
            </h5>

            <p className="text-muted mb-1">
              Hello <b>{payload.email}</b>,
            </p>

            <p className="text-muted mb-3">
              Please verify your email address by clicking the button below.
            </p>

            <button
              className="btn btn-primary w-100"
              onClick={handleVerify}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Email"}
            </button>

            <p className="text-muted small mt-4 mb-0">
              If you did not request this, please ignore this email.
              <br />
              <strong>Team Medier</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;

